import moment from "moment";

export type ReaderResponseType = {
  tooklitResponse: string;
  message: {
    "@attributes": {
      "xml:id": "message";
    };
    Header: {
      Service: string;
      Action: string;
      RequestID: string;
      Nonce: string;
      CorrelationID: string;
      CardSerialNumber: string;
      CardNumber: string;
      IDNumber: string;
      Timestamp: string;
      ValidityInterval: string;
    };
    Body: {
      "@attributes": {
        "xmlns:xsi": string;
        "xsi:type": "PublicDataDataType";
      };
      ResponseStatus: "Success" | "Fail";
      PublicData: {
        IdNumber: string;
        CardNumber: string;
        NonModifiableData: {
          IdType: {};
          IssueDate: string;
          ExpiryDate: string;
          TitleArabic: {};
          FullNameArabic: string;
          TitleEnglish: {};
          FullNameEnglish: string;
          Gender: "M" | "F";
          NationalityArabic: string;
          NationalityEnglish: string;
          NationalityCode: {};
          DateOfBirth: string;
          PlaceOfBirthArabic: {};
          PlaceOfBirthEnglish: {};
        };
        ModifiableData: {
          OccupationCode: {};
          OccupationArabic: {};
          OccupationEnglish: {};
          FamilyId: {};
          OccupationTypeArabic: {};
          OccupationTypeEnglish: {};
          OccupationFieldCode: {};
          CompanyNameArabic: {};
          CompanyNameEnglish: {};
          MaritalStatusCode: {};
          HusbandIdNumber: {};
          SponsorTypeCode: {};
          SponsorUnifiedNumber: string;
          SponsorName: {};
          ResidencyTypeCode: {};
          ResidencyNumber: {};
          ResidencyExpiryDate: {};
          PassportNumber: string;
          PassportTypeCode: {};
          PassportCountryCode: {};
          PassportCountryArabic: {};
          PassportCountryEnglish: {};
          PassportIssueDate: {};
          PassportExpiryDate: {};
          QualificationLevelCode: {};
          QualificationLevelArabic: {};
          QualificationLevelEnglish: {};
          DegreeDescriptionArabic: {};
          DegreeDescriptionEnglish: {};
          FieldOfStudyCode: {};
          FieldOfStudyArabic: {};
          FieldOfStudyEnglish: {};
          PlaceOfStudyArabic: {};
          PlaceOfStudyEnglish: {};
          DateOfGraduation: {};
          MotherFullNameArabic: {};
          MotherFullNameEnglish: {};
        };
        HomeAddress: {
          AddressTypeCode: {};
          LocationCode: {};
          EmiratesCode: {};
          EmiratesDescArabic: {};
          EmiratesDescEnglish: {};
          CityCode: {};
          CityDescArabic: {};
          CityDescEnglish: {};
          StreetArabic: {};
          StreetEnglish: {};
          POBOX: {};
          AreaCode: {};
          AreaDescArabic: {};
          AreaDescEnglish: {};
          BuildingNameArabic: {};
          BuildingNameEnglish: {};
          FlatNo: {};
          ResidentPhoneNumber: {};
          MobilePhoneNumber: string;
          Email: string;
        };
        WorkAddress: {
          AddressTypeCode: {};
          LocationCode: {};
          CompanyNameArabic: {};
          CompanyNameEnglish: {};
          EmiratesCode: {};
          EmiratesDescArabic: {};
          EmiratesDescEnglish: {};
          CityCode: {};
          CityDescArabic: {};
          CityDescEnglish: {};
          POBOX: {};
          StreetArabic: {};
          StreetEnglish: {};
          AreaCode: {};
          AreaDescArabic: {};
          AreaDescEnglish: {};
          BuildingNameArabic: {};
          BuildingNameEnglish: {};
          LandPhoneNumber: {};
          MobilePhoneNumber: {};
          Email: {};
        };
        CardHolderPhoto: string;
        HolderSignatureImage: string;
      };
    };
  };
  xmlString: string;
  response: null;
  status: "success" | "fail";
  cardNumber: string;
  cardSerialNumber: string;
  iDNumber: string;
  requestId: string;
  service: "ReadPublicDataOffline";
  timeStamp: string;
  cardHolderPhoto: string;
  holderSignatureImage: string;
  modifiablePublicData: {
    occupationCode: {};
    occupationArabic: {};
    occupationEnglish: {};
    familyID: {};
    occupationTypeArabic: {};
    occupationTypeEnglish: {};
    occupationFieldCode: {};
    companyNameArabic: {};
    companyNameEnglish: {};
    maritalStatusCode: {};
    husbandIdNumber: {};
    sponsorTypeCode: {};
    sponsorUnifiedNumber: string;
    sponsorName: {};
    residencyTypeCode: {};
    residencyNumber: {};
    residencyExpiryDate: {};
    passportNumber: string;
    passportTypeCode: {};
    passportCountryCode: {};
    passportCountryArabic: {};
    passportCountryEnglish: {};
    passportIssueDate: {};
    passportExpiryDate: {};
    qualificationLevelCode: {};
    qualificationLevelArabic: {};
    qualificationLevelEnglish: {};
    degreeDescriptionArabic: {};
    degreeDescriptionEnglish: {};
    fieldOfStudyArabic: {};
    fieldOfStudyEnglish: {};
    fieldOfStudyCode: {};
    placeOfStudyArabic: {};
    placeOfStudyEnglish: {};
    dateOfGraduation: {};
    motherFullNameArabic: {};
    motherFullNameEnglish: {};
  };
  nonModifiablePublicData: {
    iDType: {};
    gender: "M" | "F";
    dateOfBirth: string;
    issueDate: string;
    expiryDate: string;
    titleArabic: {};
    titleEnglish: {};
    fullNameArabic: string;
    fullNameEnglish: string;
    nationalityArabic: string;
    nationalityEnglish: string;
    nationalityCode: {};
    placeOfBirthArabic: {};
    placeOfBirthEnglish: {};
  };
  homeAddress: {
    addressTypeCode: {};
    flatNo: {};
    buildingNameArabic: {};
    buildingNameEnglish: {};
    streetArabic: {};
    streetEnglish: {};
    locationCode: {};
    areaCode: {};
    areaDescArabic: {};
    areaDescEnglish: {};
    emiratesCode: {};
    pOBOX: {};
    cityCode: {};
    cityDescArabic: {};
    cityDescEnglish: {};
    emiratesDescArabic: {};
    emiratesDescEnglish: {};
    email: string;
    residentPhoneNumber: {};
    mobilePhoneNumber: string;
  };
  workAddress: {
    addressTypeCode: {};
    locationCode: {};
    companyNameArabic: {};
    companyNameEnglish: {};
    emiratesCode: {};
    emiratesDescArabic: {};
    emiratesDescEnglish: {};
    cityCode: {};
    cityDescArabic: {};
    cityDescEnglish: {};
    pOBOX: {};
    streetArabic: {};
    streetEnglish: {};
    areaCode: {};
    areaDescArabic: {};
    areaDescEnglish: {};
    buildingNameArabic: {};
    buildingNameEnglish: {};
    landPhoneNumber: {};
    mobilePhoneNumber: {};
    email: {};
  };
};

export type ReaderDataType = {
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  countryCode: string | null;
  mobileNo: string | null;
  email: string | null;
  emiratesId: string | null;
  dob: string | null;
  gender: "M" | "F" ;
  nationality?: string | null;
  cardHolderPhoto:string | null;
};

export const formatCardReaderResponse = (data: ReaderResponseType): ReaderDataType => {
  const formattedData: ReaderDataType = {
    emiratesId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    countryCode: "",
    mobileNo: "",
    email: "",
    dob: "",
    gender: "F",
    nationality:"",
    cardHolderPhoto:"",
  };
  let cPartNumber1 =
    (
      data.message?.Header?.IDNumber ||
      data?.message?.Body?.PublicData?.IdNumber
    )?.slice(0, 3) || null;
  let cPartNumber2 =
    (
      data.message?.Header?.IDNumber ||
      data?.message?.Body?.PublicData?.IdNumber
    )?.slice(3, 7) || null;
  let cPartNumber3 =
    (
      data.message?.Header?.IDNumber ||
      data?.message?.Body?.PublicData?.IdNumber
    )?.slice(7, 14) || null;
  let cPartNumber4 =
    (
      data.message?.Header?.IDNumber ||
      data?.message?.Body?.PublicData?.IdNumber
    )?.slice(
      14,
      data?.message?.Header?.IDNumber?.length ||
        data?.message?.Body?.PublicData?.IdNumber?.length
    ) || null;
  if (cPartNumber1 && cPartNumber2 && cPartNumber3 && cPartNumber4) {
    formattedData.emiratesId = `${cPartNumber1}-${cPartNumber2}-${cPartNumber3}-${cPartNumber4}`;
  }
  let spliteName = (data?.nonModifiablePublicData.fullNameEnglish || data?.message?.Body?.PublicData?.NonModifiableData?.FullNameEnglish)?.split(",")?.filter(name=>name !== "") || [];
  if( spliteName.length > 0) {
    formattedData.firstName = spliteName[0] || null;
    formattedData.middleName = spliteName[1] || null;
    formattedData.lastName = spliteName[2] || null;
  }
  formattedData.countryCode = (data?.homeAddress?.mobilePhoneNumber || data?.message?.Body?.PublicData?.HomeAddress?.MobilePhoneNumber)?.slice(0, 3) || null;
  formattedData.mobileNo = (data?.homeAddress?.mobilePhoneNumber || data?.message?.Body?.PublicData?.HomeAddress?.MobilePhoneNumber)?.slice(3, (data?.homeAddress?.mobilePhoneNumber?.length || data?.message?.Body?.PublicData?.HomeAddress?.MobilePhoneNumber?.length || 0)) || null;
  formattedData.email = data?.homeAddress?.email || data?.message?.Body?.PublicData?.HomeAddress?.Email || null;
  formattedData.dob = moment(data?.nonModifiablePublicData.dateOfBirth || data?.message?.Body?.PublicData?.NonModifiableData?.DateOfBirth,"DD/MM/YYYY").format("YYYY-MM-DD") || null;
  formattedData.gender = data?.nonModifiablePublicData?.gender || data?.message?.Body?.PublicData?.NonModifiableData.Gender || ""
  formattedData.nationality = data?.nonModifiablePublicData?.nationalityEnglish || data?.message?.Body?.PublicData?.NonModifiableData.NationalityEnglish || null;
  formattedData.cardHolderPhoto = (data.cardHolderPhoto || data.message?.Body?.PublicData?.CardHolderPhoto) ? `data:image/jpeg;base64,${(data.cardHolderPhoto || data.message?.Body?.PublicData?.CardHolderPhoto)}` : null
  return formattedData;
};


